module.exports = __webpack_public_path__ + "static/media/sanitaria-02.15ea44a5.jpg";